import React, { Component } from 'react'

export class Compte extends Component {
    render() {
        return (
            <div>
                component compte !
            </div>
        )
    }
}

export default Compte
